import { useMutation } from '@tanstack/react-query';
import { changeAuthenticatedUserPassword } from '../services/auth';

export const useChangePasswordMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ currentPassword, newPassword }) => {
      const result = await changeAuthenticatedUserPassword({
        currentPassword,
        newPassword,
      });
      if (!result.success) {
        const error = new Error(result.message || 'Failed to change password');
        error.fieldErrors = result.fieldErrors;
        throw error;
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
